(function () {
  const style = document.createElement('style');
  style.textContent = `
    .cart-item--bundle {
      border-left: 3px solid rgb(var(--btn-bg-color, 207 176 145));
      padding-left: 10px;
    }
    .cart-item__quantity--bundle {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 6px;
      justify-content: center;
    }
    .cart-item__bundle-label {
      font-size: 0.72em;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      opacity: 0.55;
    }
    .cart-item__remove-bundle {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      font: inherit;
      color: inherit;
      text-decoration: underline;
      font-size: 0.85em;
    }
    .cart-item__remove-bundle:disabled {
      opacity: 0.5;
      cursor: default;
    }
  `;
  document.head.appendChild(style);

  // Show "Remove bundle" only on the last item of each bundle group
  function syncBundleUI() {
    const groups = {};
    document.querySelectorAll('.cart-item[data-bundle-id]').forEach(function (el) {
      var id = el.dataset.bundleId;
      if (!groups[id]) groups[id] = [];
      groups[id].push(el);
    });

    Object.values(groups).forEach(function (items) {
      items.forEach(function (item, i) {
        var btn = item.querySelector('[data-bundle-remove]');
        if (btn) btn.style.display = (i === items.length - 1) ? '' : 'none';
      });
    });
  }

  syncBundleUI();
  document.addEventListener('on:cart:after-merge', syncBundleUI);
  document.addEventListener('on:cart-drawer:after-open', syncBundleUI);

  // Remove bundle click
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-bundle-remove]');
    if (!btn) return;
    e.preventDefault();

    const bundleId = btn.dataset.bundleId;
    const items = document.querySelectorAll('.cart-item[data-bundle-id="' + bundleId + '"]');

    const updates = {};
    items.forEach(function (el) {
      if (el.dataset.itemKey) updates[el.dataset.itemKey] = 0;
    });

    if (!Object.keys(updates).length) return;

    const allBtns = document.querySelectorAll('[data-bundle-remove][data-bundle-id="' + bundleId + '"]');
    allBtns.forEach(function (b) { b.disabled = true; b.textContent = 'Removing…'; });

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (document.querySelector('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      } else {
        location.reload();
      }
    } catch {
      allBtns.forEach(function (b) { b.disabled = false; b.textContent = 'Remove bundle'; });
    }
  });
})();
